<div class="timer flex flex-row">
  {{ timerValue }}
</div>
